"use strict";

var _interopRequireDefault = require("/Users/chuongdev/Desktop/project/209web_admin-chung-cu/node_modules/@babel/runtime/helpers/interopRequireDefault.js").default;
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
require("core-js/modules/es.json.stringify.js");
require("core-js/modules/es.object.to-string.js");
require("core-js/modules/web.dom-collections.for-each.js");
var _regeneratorRuntime2 = _interopRequireDefault(require("/Users/chuongdev/Desktop/project/209web_admin-chung-cu/node_modules/@babel/runtime/helpers/regeneratorRuntime.js"));
var _asyncToGenerator2 = _interopRequireDefault(require("/Users/chuongdev/Desktop/project/209web_admin-chung-cu/node_modules/@babel/runtime/helpers/asyncToGenerator.js"));
var _index = _interopRequireDefault(require("../index"));
var _settings = require("@/settings");
function getDefaultState() {
  return {
    routes: [],
    constRoutes: []
  };
}
var state = getDefaultState;
var mutations = {
  SET_ROUTES: function SET_ROUTES(state, routes) {
    state.routes = routes;
  },
  SET_CONST_ROUTES: function SET_CONST_ROUTES(state, value) {
    state.constRoutes = value;
  }
};
var actions = {
  setRoutesAccess: function setRoutesAccess(_ref, constantRoutes) {
    return (0, _asyncToGenerator2.default)( /*#__PURE__*/(0, _regeneratorRuntime2.default)().mark(function _callee() {
      var commit, routesAccess, tmpConst, _tmpConst;
      return (0, _regeneratorRuntime2.default)().wrap(function _callee$(_context) {
        while (1) {
          switch (_context.prev = _context.next) {
            case 0:
              commit = _ref.commit;
              try {
                if (_settings.checkPermission) {
                  routesAccess = _index.default.state.user.info.role.permissions;
                  commit("SET_ROUTES", routesAccess);
                  tmpConst = JSON.parse(JSON.stringify(constantRoutes));
                  routesAccess.forEach(function (element) {
                    var parentPath = element.path.split("/")[1];
                    var childPath = element.path.split("/")[2];
                    tmpConst.forEach(function (route) {
                      if (route.path == "/" + parentPath) {
                        route.access = true;
                        route.children.forEach(function (child) {
                          if (child.path == childPath) {
                            child.access = true;
                          }
                        });
                      }
                    });
                  });
                  commit("SET_CONST_ROUTES", tmpConst);
                } else {
                  _tmpConst = JSON.parse(JSON.stringify(constantRoutes));
                  commit("SET_CONST_ROUTES", _tmpConst);
                }
              } catch (error) {
                console.log('setRoutesAccess err', error);
              }
            case 2:
            case "end":
              return _context.stop();
          }
        }
      }, _callee);
    }))();
  }
};
var getters = {};
var _default = {
  namespaced: true,
  state: state,
  mutations: mutations,
  actions: actions
};
exports.default = _default;